export const harness = [
    {
        key: 'qualification:harnessedMounted:harnessed',
        value: 'harnessed',
    },
    {
        key: 'qualification:harnessedMounted:mounted',
        value: 'mounted',
    },
]